/**
 * @file 微社区入口文件
 * @author hardylin <hardylin@tencent.com>
 */
import * as Sentry from '@sentry/browser'
import Vue from 'vue'
import Aegis from '@tencent/aegis-web-sdk'
import SlugUI, { Toast } from '@tencent/slug-ui'
import SlugComment from '@tencent/comment'
// import SlugQA from '@tencent/slug-qa'
// import { Dmpt } from '@tencent/slug-report'

// #region 图片预览
import 'vue-photo-preview/dist/skin.css'
import preview from 'vue-photo-preview'
// #endregion

// #region 样式布局
import '../styles/index.css'
// #endregion

import { getUrlParam } from './utils/index'
import './filters'
import directives from './directives'
// import routes from './routes'
import router from './router'
import store from './store'
import App from '../modules/app/index.vue'

// dmpt为临时支持版本 直接通过js cdn引入，再注入Vue，方便及时更新
let Dmpt = window.SlugDmpt
Vue.use(Dmpt)
Vue.use(SlugUI)
Vue.use(SlugComment)
// Vue.use(SlugQA)
Vue.use(preview,{
  fullscreenEl:false,
})
Vue.use(directives)

// SlugQA 实例
Vue.mixin({
  beforeCreate() {
    const options = this.$options;
    if (options.qa) {
      this.$qa = options.qa;
    } else if (options.parent && options.parent.$qa) {
      this.$qa = options.parent.$qa;
    }
  },
});
// SlugQA 异步组件
let slugQaCompsCache = undefined;
let slugQaComps = (name) => {
  if (!slugQaCompsCache) {
    slugQaCompsCache = import(/* webpackChunkName: 'slug-qa' */ '@tencent/slug-qa/dist/component.esm');
  }
  return () => slugQaCompsCache.then(comps => comps[name])
}
Vue.component('slug-qa-center-pane', slugQaComps('QaCenterPane'));
Vue.component('slug-qa-detail', slugQaComps('QaDetail'));
Vue.component('slug-qa-find', slugQaComps('QaFind'));
Vue.component('slug-qa-ask', slugQaComps('QaAsk'));
Vue.component('slug-qa-search', slugQaComps('QaSearch'));

let dmp = new Dmpt({
    game: sessionStorage.igGame
})

dmp.regRouter(router)

if (process.env.NODE_ENV == 'production' && sessionStorage.igEnv != 'development') {

    /* #region Sentry */
    Sentry.init({
        dsn: 'https://0a19090654864e93944fb6dff234e9a9@report.url.cn/sentry/854',
        environment: process.env.NODE_ENV,
        release: WP_VERSION,
        beforeSend(data) {

            /* #region 不上报低版本浏览器内核产生的错误，与 browserslist 保持一致 */
            const chrome = navigator.userAgent.match(/Chrome\/(\d+)/)
            const ios = navigator.userAgent.match(/OS (\d+)/)
            if (Array.isArray(chrome) && chrome[1] < 33 || Array.isArray(ios) && ios[1] < 9) {
                return null
            } else {
                return data
            }
            /* #endregion */
            
        }
    })
    Sentry.configureScope(scope => {
        scope.setUser({
            openid: getUrlParam('openid', sessionStorage.tokenParams),
        })
    })
    /* #endregion */

    /* #region aegis */
    window.aegisReport = new Aegis({
        id: 2366, // 在 aegis.ivwe.io 申请到的 id
        uin: getUrlParam('openid', sessionStorage.tokenParams),
        listenOnerror: false,
        reportApiSpeed: true, // 接口测速
        reportAssetSpeed: true, // 静态资源测速
    });
    /* #endregion */
}


// #region SDK BUG 临时降级处理
if (store.state.global.game == 'xj4') {
    document.querySelector('meta[name="viewport"]').content = 'width=device-width, initial-scale=1.0, user-scalable=no'
}
// #endregion

window.timeVisit = new Date()

function initApp() {
    if (window.config) {
        SlugUI.config.colors = window.config.theme.color
        store.commit('global/updateConfig', window.config)

        // SlugQA 配置
        const qaCfg = window.config.navigators.qa;
        const downloadNav = window.config.download_nav;
        const slugQACfg = {
          options: {
            game: store.state.global.game,
            bhost: [
              'sy.qq.com',
              sessionStorage.igEnv == 'development' ? '' : 'test.ingame.qq.com',
            ],
          },
          theme: {
            colors: Object.assign({}, window.config.theme.color, {
              6: undefined, // 通用微社区已设置背景色，通用问答不用设置背景色
            }),
            searchbg: qaCfg ? qaCfg.searchbg : undefined,
            download: (downloadNav && downloadNav.active) ? {
              url: downloadNav.download_url,
              img: downloadNav.img_url ,
            } : undefined,
          },
          nav: {
            back: true,
            find: {
              name: 'qa',
            },
            search: {
              name: 'qa',
              query: {
                qa_page: 'search',
              },
            },
            ask: {
              name: 'qa',
              query: {
                qa_page: 'ask',
              },
            },
            detail(id) {
              console.log('detail', id)
              return { 
                name: 'qa-detail',
                params: { id },
              };
            },
          },
          inject: {
            // UI 组件
            SlugUI: { Toast },
            // 分享组件：需要sdk支持：msdk3->1 msdk5->2 其它->1
            SlugShare: `https://tiem-cdn.qq.com/slugteam/components/share/v${ingameEnvCheck.slugQAMSDKV5?2:1}.0/slug-share.min.js`,
            shareURL: (qid) => sessionStorage.igEnv === 'development'
              ? `https://test.ingame.qq.com/${store.state.global.game}/common/#/qa/share/${qid}`
              : `https://sy.qq.com/${store.state.global.game}/ingame/#/qa/share/${qid}`,
            shareImg: `https://tiem-cdn.qq.com/sy/${store.state.global.game}/ingame/images/${sessionStorage.igEnv === 'development' ? 'test_' : ''}qashare.png`,
            // 上报组件
            report({
              type,
              en,
              zh,
              targetid,
              action = 'pop',
              targettype = 'other',
              from = 'ingame',
            }) {
              console.log(type, en, zh)
              // mta.reportStat(en);
              targetid
                ? dmp.report({
                    action,
                    targetid,
                    targettype,
                    from,
                  })
                : PTTSendClick(type, en, zh);
            },
          },
        };
        Vue.mixin({
          beforeCreate() {
            this.$qaCfg = slugQACfg;
          },
        });

        new Vue({
            el: '#app',
            render: h => h(App),
            router,
            store,
            dmp,
            comment: new SlugComment({
                options: {
                    gameid: store.state.global.game,
                    moduleId: 'ingame'
                },
                env: sessionStorage.igEnv == 'development' ? 'development' : 'production'
            }),
            // qa: new SlugQA(slugQACfg),
        })
    } else {
        requestAnimationFrame(initApp)
    }
}
requestAnimationFrame(initApp)
